module.exports = __webpack_public_path__ + "static/media/ava1.91fbd8f5.svg";